import { createContext, useState } from "react";
import { VideoPlaybackContextValue, VideoInnerState } from "./types";
import { MediaPlayer } from "dashjs";
import { useObservable } from "@legendapp/state/react";

export const VideoPlaybackContext = createContext<VideoPlaybackContextValue>(
  {} as VideoPlaybackContextValue
);

const DEFAULT_CAMERA = "6";
const getPersistedCamera = () =>
  localStorage.getItem("selectedCamera") || DEFAULT_CAMERA;

export function VideoPlaybackProvider({ children }: React.PropsWithChildren) {
  const videoContext = useObservable<VideoInnerState>({
    startTime: null,
    error: null,
    camera: getPersistedCamera(),
    timeToContinue: null,
    endTime: null,
    duration: 0,
    isStandalone: false,
    availabilityStartTime: null,
  });

  const [dashPlayer] = useState(() => MediaPlayer().create());

  const timeAsUTC = () => {
    const availabilityStartTime = videoContext.availabilityStartTime.peek();

    if (dashPlayer.isDynamic()) {
      return dashPlayer.timeAsUTC() * 1000;
    }

    if (!availabilityStartTime) {
      return 0;
    }

    return availabilityStartTime.getTime() + dashPlayer.time() * 1000;
  };

  return (
    <VideoPlaybackContext.Provider
      value={{
        dashPlayer,
        timeAsUTC,
        videoContext,
      }}
    >
      {children}
    </VideoPlaybackContext.Provider>
  );
}
